import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDReports = createAsyncThunk(
    'fetchPDDReports',
    async ({ jwtBearer, movement }) => {
        const response = await fetch(`${BASE_URL}pdd/get/pdd/data/?movement=${movement}`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddDataReportsSlice = createSlice({
    name: 'pddDataReportsSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDReports.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDReports.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDReports.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddDataReportsSlice.reducer
